const styles = {
  spinnerContainer: {
    marginTop: 4,
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '200px',
    height: '200px'
  }
};

export default styles;
